import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
            品牌故事
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {aboutData.title}
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-3xl mx-auto">
            {aboutData.description}
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
            {aboutData.features.map((feat, idx) => (
              <div key={idx} className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${feat.icon} text-primary-600 text-lg`}></i>
                </div>
                <span className="text-sm text-foreground-700">{feat.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}